module.exports = __webpack_public_path__ + "img/Flag_of_Gibraltar.178e56f2.svg";